export default {
  conversation_dnd_message: '{name} è su DND',
  conversation_dnd_message_with_time:
    '{name}è su DND fino a {time, time, short}',
  conversation_dnd_message_tooltip_content: '{name} non riceverà notifiche',
};
